// State
import { select, Store } from "@ngrx/store";
// RxJS
// CRUD
import { BaseDataSource, QueryResultsModel } from "../_base/crud";
import { AppState } from "../reducers";
// Selectors
import {
  selectPromotionsInitWaitingMessage,
  selectPromotionsInStore,
  selectPromotionsPageLoading
} from "./promotions.selectors";

export class PromotionsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();
    this.loading$ = this.store.pipe(select(selectPromotionsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectPromotionsInitWaitingMessage));

    this.store.pipe(select(selectPromotionsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
